<template>
  <!-- TODO - this needs to implement all other cases -->
  <VTooltip
    ref="tooltipRef"
    activator="parent"
    class="iconn_tooltip"
    :location="location"
    :disabled="disabledTooltip"
    :max-width="maxWidth"
    :eager="false"
  >
    {{ text }}
    <slot name="content"></slot>
  </VTooltip>
</template>

<script lang="ts" setup>
import { computed, defineProps, ref, watch, withDefaults } from 'vue';
import type { VTooltip } from 'vuetify/components';
type Location = VTooltip['$props']['location'];

const props = withDefaults(
  defineProps<{
    text: string | number;
    maxWidth?: number;
    location?: Location;
    autoDisable?: boolean;
    disabled?: boolean;
  }>(),
  {
    location: 'top',
    disabled: false,
    autoDisable: false,
  },
);

const hasTextTruncate = ref(false);
const tooltipRef = ref();

const resizeObserver = new ResizeObserver((entries) => {
  const element = entries?.[0]?.target;
  const contentWidth = element?.scrollWidth;
  const containerWidth = element?.clientWidth;
  hasTextTruncate.value = contentWidth > containerWidth;
});

watch(
  () => tooltipRef.value?.activatorEl,
  (element) => {
    if (element && props.autoDisable) {
      resizeObserver.observe(element);
    }
  },
);

const disabledTooltip = computed(() => {
  if (props.disabled) {
    return true;
  }
  return props.autoDisable && !hasTextTruncate.value;
});
</script>

<style lang="scss">
@import '@foundation';

.iconn_tooltip {
  .v-overlay__content {
    @extend .typography_default;
    @extend .gray-shadow-md;
    @extend .border_rounded_sm;
    background-color: map-get($basic, 'white');
    padding: 4px 8px;
    white-space: pre-wrap;
  }
}
</style>
